export default "<div style=\"margin-bottom: 40px;\">\n    <canvas #curveChart width=\"400\" height=\"100\"></canvas>\n</div>\n  ";